(function () {
  // Uses the shop money format (same output as the Liquid money filter) instead of the localized currency symbol.
  function formatMoney(cents, format) {
    const value = (Number(cents) || 0) / 100;
    const group = (amount, decimals, thousands, decimal) => {
      const parts = amount.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimal + parts[1] : parts[0];
    };
    return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function initPremiumAtc() {
    document.querySelectorAll('[id^="PremiumAtcData-"]').forEach(function (dataNode) {
      if (dataNode.dataset.bound === 'true') return;
      dataNode.dataset.bound = 'true';

      let data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }

      const sectionId = data.sectionId;
      const form = document.getElementById('product-form-' + sectionId);
      const button = document.getElementById('ProductSubmitButton-' + sectionId);

      if (!form || !button) return;

      const idInput = form.querySelector('.product-variant-id');
      const label = button.querySelector('[data-premium-atc-label]');
      const price = button.querySelector('[data-premium-atc-price]');
      const compare = button.querySelector('[data-premium-atc-compare]');
      const save = button.querySelector('[data-premium-atc-save]');
      const reassurance = form.closest('.product-form')?.querySelector('[data-premium-atc-reassurance-row]');

      function getVariant() {
        if (!idInput) return null;
        const id = String(idInput.value || '');
        return (data.variants || []).find(function (variant) {
          return String(variant.id) === id;
        }) || null;
      }

      function updateButtonUi() {
        const variant = getVariant();
        if (!variant) {
          if (label) label.textContent = data.labels.unavailable;
          button.disabled = true;
          return;
        }

        const isSoldOut = !variant.available;

        if (label) {
          label.textContent = isSoldOut ? data.labels.soldOut : data.labels.add;
        }

        button.disabled = isSoldOut;

        if (price && data.showPrice) {
          price.textContent = formatMoney(variant.price, data.moneyFormat);
        }

        if (compare) {
          if (data.showCompare && variant.compare_at_price > variant.price && !isSoldOut) {
            compare.textContent = formatMoney(variant.compare_at_price, data.currencySymbol);
            compare.classList.remove('hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('hidden');
          }
        }

        if (save) {
          const hasDiscount = variant.compare_at_price > variant.price;
          if (data.showSave && hasDiscount && !isSoldOut) {
            const savePercent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            save.textContent = data.savePrefix + ' ' + savePercent + '%';
            save.classList.remove('hidden');
          } else {
            save.textContent = '';
            save.classList.add('hidden');
          }
        }

        if (reassurance) {
          reassurance.style.display = isSoldOut ? 'none' : '';
        }
      }

      updateButtonUi();

      form.addEventListener('change', function () {
        setTimeout(updateButtonUi, 50);
      });

      form.addEventListener('submit', function () {
        if (label && !button.disabled) {
          label.textContent = data.labels.loading;
        }
      });

      button.addEventListener('click', function () {
        if (button.disabled) return;

        setTimeout(function () {
          if (!button.disabled && label) {
            label.textContent = data.labels.added;

            setTimeout(function () {
              updateButtonUi();
            }, 1000);
          }
        }, 250);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPremiumAtc);
  document.addEventListener('shopify:section:load', initPremiumAtc);
})();